<footer data-aos="zoom-in-down" data-aos-delay="1000" data-aos-duration="1000">
    <label>Powered by <a (click)="redirectToMainPortal()">Univariety</a></label>
    <p>International Educational Gateway Pvt. Ltd. © 2021. All Rights Reserved. Univariety</p>
</footer>
